const Constants = {
    heating_a: -22.54555315,
    heating_b: 8.805689712,
    heating_c: 0.029225228,
    heating_d: 71.97385151,
    heating_min_heat: 4.8,
    heating_min_heat_norm: 0.00,
    heating_max_heat: 112.6,
    heating_max_heat_norm: 1.00,
    //used for heating normazization as told in the normalization column in algo excel doc
    heating_norm: 0.809,



    //window types
    heating_awn: 0.195,
    heating_cas: 0.195,
    heating_tnt: 0.195,

    heating_awn_star: 1.5,
    heating_cas_star: 1.5,
    heating_tnt_star: 1.5,


    //cooling
    heatingstar_e55: -8.0,
    heatingstar_e56: 18,
    heatingstar_e57: 4.8,
    heatingstar_e58: 132.938,



    cooling_a: 5.480465406,
    cooling_b: 5.755247583,
    cooling_c: 106.0894811,
    cooling_d: -90.691827,
    cooling_e: 99.1227545,
    cooling_min_cool: 6.1,
    cooling_min_cool_norm: 0.00,
    cooling_max_cool: 124.3,
    cooling_max_cool_norm: 1.00,
    cooling_norm: 1.000,

    coolingstar_m55: -3.0,
    coolingstar_m56: 13,
    coolingstar_m57: 6.1,
    coolingstar_m58: 80.654968,



};

export class WERSRatingResults {
    uValue: number;
    shgc: number;
    operatingType: string;
    heatingPercentage: number;
    coolingPercentage: number;
    heatingStars: number;
    coolingStars: number;
    constructor(uValue: number, sHGC: number, operatingType: string, heatingPercentage: number, coolingPercentage: number, heatingStars: number, coolingStars: number) {
        this.uValue = uValue;
        this.shgc = sHGC;
        this.operatingType = operatingType;
        this.heatingPercentage = heatingPercentage;
        this.coolingPercentage = coolingPercentage;
        this.heatingStars = heatingStars;
        this.coolingStars = coolingStars;
    }

}

export function getWERSRatingResults(uValue: number, shgc: number, windowType: string): WERSRatingResults {
    return new WERSRatingResults(uValue, shgc, windowType,
        HeatingPercentage(uValue, shgc, windowType),
        CoolingPercentage(uValue, shgc, windowType),
        HeatingStars(uValue, shgc, windowType),
        CoolingStars(uValue, shgc, windowType));
}

function HeatingPercentage(uValue: number, shgc: number, windowType: string) {
    //heating = heating_a+(heating_b*x)+ (heating_c*(pow(x,3))) + (pow((heating_d),exp(-y)));
    var heat = Constants.heating_a + Constants.heating_b * uValue + Constants.heating_c * Math.pow(uValue, 3) + Constants.heating_d * Math.exp(-shgc);
    var norm = (heat - Constants.heating_min_heat) / (Constants.heating_max_heat - Constants.heating_min_heat);

    var percentage = -(norm - Constants.heating_norm) / Constants.heating_norm;
    //percent = substr(percentage,2,strpos(percentage,".") + 1).'.'.substr(percentage,4,strpos(percentage,".") + 1);

    windowType = windowType.toLowerCase();
    let finalpercentage = percentage;

    if (windowType == "awning window") {
        finalpercentage = percentage + Constants.heating_awn;
    }
    else if (windowType == "casement window") {
        finalpercentage = percentage + Constants.heating_cas;
    }
    else if (windowType == "tilt & turn window") {
        finalpercentage = percentage + Constants.heating_tnt;
    }

    //verify this looks like an actual percentage figure. 
    if (finalpercentage < 0.0)
        return 0;
    else
        return Math.round(finalpercentage * 100);
}
function HeatingStars(uValue: number, shgc: number, windowType: string) {
    //uval = 1.923;
    //shgc = 0.478;

    var heat = Constants.heating_a + Constants.heating_b * uValue + Constants.heating_c * Math.pow(uValue, 3) + Constants.heating_d * Math.exp(-shgc);
    /*
        =E55 + E56 *
        EXP(
        - ( heat - E57 ) / E58
        )

        from excel used this formula


    */
    var rawstar = Constants.heatingstar_e55 + Constants.heatingstar_e56 * Math.exp(-(heat - Constants.heatingstar_e57) / Constants.heatingstar_e58);
    let star = rawstar;
    windowType = windowType.toLowerCase();

    if (windowType == "awning window") {
        star = rawstar + Constants.heating_awn_star;
    }

    else if (windowType == "casement window") {
        star = rawstar + Constants.heating_cas_star;
    }

    else if (windowType == "tilt & turn window") {
        star = rawstar + Constants.heating_tnt_star;
    }


    return parseFloat(star.toFixed(1));
}

function CoolingPercentage(uValue: number, shgc: number, windowType: string) {
    var cool = Constants.cooling_a + Constants.cooling_b * uValue + Constants.cooling_c * shgc + Constants.cooling_d * Math.pow(shgc, 2) + Constants.cooling_e * Math.pow(shgc, 3);
    var normcool = (cool - Constants.cooling_min_cool) / (Constants.cooling_max_cool - Constants.cooling_min_cool);

    //=-(N36-N17)/N17
    var percentage = -(normcool - Constants.cooling_norm) / Constants.cooling_norm;
    var finalpercentage = percentage;


    //verify this looks like an actual percentage figure. 
    if (finalpercentage < 0.0)
        return 0;
    else
        return Math.round(finalpercentage * 100);


}

function CoolingStars(uValue: number, shgc: number, windowType: string) {
    var cool = Constants.cooling_a + Constants.cooling_b * uValue + Constants.cooling_c * shgc + Constants.cooling_d * Math.pow(shgc, 2) + Constants.cooling_e * Math.pow(shgc, 3);
    //=M55+M56*EXP(-(M36-M57)/M58)
    var rawstar = Constants.coolingstar_m55 + Constants.coolingstar_m56 * Math.exp(-(cool - Constants.coolingstar_m57) / Constants.coolingstar_m58);
    var star = rawstar;
    return parseFloat(star.toFixed(1));
}


